export default __webpack_public_path__ + "ui/assets/img/arrow-left-32.svg";